import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTv = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9 21C8.71667 21 8.47933 20.904 8.288 20.712C8.096 20.5207 8 20.2833 8 20V19H4C3.45 19 2.97933 18.8043 2.588 18.413C2.196 18.021 2 17.55 2 17V5C2 4.45 2.196 3.979 2.588 3.587C2.97933 3.19567 3.45 3 4 3H20C20.55 3 21.021 3.19567 21.413 3.587C21.8043 3.979 22 4.45 22 5V17C22 17.55 21.8043 18.021 21.413 18.413C21.021 18.8043 20.55 19 20 19H16V20C16 20.2833 15.9043 20.5207 15.713 20.712C15.521 20.904 15.2833 21 15 21H9ZM4 17H20V5H4V17Z",
		fill: "currentColor"
	})
});
export default SvgTv;
